const convertToFloatSeparator = (value) => value || typeof value === 'number' ? value.toString().replace(',', '.') : null;
export default convertToFloatSeparator;
